import { t } from 'mobx-state-tree';

/**
 * FamilyMetadata Model - Lightweight family info for picker
 */
export const FamilyMetadataModel = t.model('FamilyMetadataModel', {
  id: t.identifier,
  name: t.string,
  displayName: t.optional(t.string, ''), // User's effective name (alternative or canonical)
  alternativeName: t.maybeNull(t.string), // User's custom alternative, if set
  plan: t.optional(t.string, 'free'), // free | paid | gifted (gifted when API exposes it)
  memberCount: t.optional(t.number, 0),
  createdAt: t.optional(t.string, ''),
  updatedAt: t.optional(t.string, ''),
  createdBy: t.maybeNull(t.string),
  createdByNickname: t.maybeNull(t.string),
  updatedBy: t.maybeNull(t.string),
  updatedByNickname: t.maybeNull(t.string),
  /** Latest family-visible activity time (Recent activity). Empty until loaded. */
  lastActivityAt: t.optional(t.string, ''),
  /** Actor label for that activity, matching Recent activity. */
  lastActivityBy: t.maybeNull(t.string),
  userRole: t.maybeNull(t.string), // User's role in this family (owner, admin, editor, contributor, viewer)
  canDeleteFamily: t.optional(t.boolean, false) // True when user has family:delete (owner only, from capability matrix)
});
